<template>
  <div id="app">
    <div v-if="vernuevo == 0">
      <v-app id="inspire">
        <v-card max-width="1000">
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-dialog
                  ref="dialog1"
                  v-model="modal1"
                  :return-value.sync="fecha1"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fecha1"
                      :readonly="fecha1 == 1"
                      label="Fecha de Inicio"
                      prepend-icon="event"
                      v-bind="attrs"
                      v-on="on"
                      solo
                      @click="listar()"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fecha1"
                    scrollable
                    locale="es-es"
                    :readonly="fecha1 == 1"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal1 = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog1.save(fecha1), listar()"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>

              <v-col cols="12" md="6">
                <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="fecha2"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fecha2"
                      :readonly="fecha2 == 1"
                      label="Fecha Fin"
                      prepend-icon="event"
                      v-on="on"
                      solo
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fecha2"
                    scrollable
                    locale="es-es"
                    :readonly="fecha2 == 1"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog.save(fecha2), listar()"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>

              <v-col cols="12" md="3">
                <v-text-field
                  v-model="hectareasfisicas"
                  label="Hectareas Fisicas"
                  outlined
                  type="number"
                  readonly
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="3">
                <v-text-field
                  v-model="hectareasriego"
                  label="Hectareas Riego"
                  outlined
                  type="number"
                  readonly
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="3">
                <v-text-field
                  v-model="totalhasriego"
                  label="Total Has Riego"
                  outlined
                  type="number"
                  readonly
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="3">
                <v-text-field
                  v-model="hecvolumen"
                  label="Vol Neto"
                  outlined
                  type="number"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>

          <v-toolbar color="light-blue" dark>
            <v-toolbar-title>
              <v-icon>compost</v-icon>
            </v-toolbar-title>

            <v-container>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  solo-inverted
                  label="Buscar"
                  class="texto1"
                  v-model="buscar"
                ></v-text-field>
              </v-col>
            </v-container>

            <v-btn icon @click="listarlike()">
              <v-icon>search</v-icon>
            </v-btn>

            <v-btn icon @click="nuevoriego()">
              <v-icon>forest</v-icon>
            </v-btn>
          </v-toolbar>

          <v-list subheader>
            <v-subheader inset> </v-subheader>

            <v-list-item v-for="riego in riegos" :key="riego.riegoid">
              <v-list-item-content>
                <v-list-item-title class="texto">{{
                  riego.usuariomodulonombrecompleto
                }}</v-list-item-title>
                <v-list-item-subtitle class="texto2"
                  >Numero de Ficha:
                  {{ riego.pagousuariomoduloid }}</v-list-item-subtitle
                >
                <v-list-item-subtitle class="texto2"
                  >Cultivo: {{ riego.cultivonombre }}</v-list-item-subtitle
                >
                <v-list-item-subtitle class="texto2"
                  >Fecha: {{ riego.riegofecha }}</v-list-item-subtitle
                >
                <v-list-item-subtitle class="texto2"
                  >Hectareas Regadas:
                  {{
                    riego.pagousuariomodulohectareasregadas
                  }}</v-list-item-subtitle
                >
                <v-list-item-subtitle class="texto2"
                  >Volumen: {{ riego.volumen }}</v-list-item-subtitle
                >
                <v-list-item-subtitle class="texto2"
                  >Riego Numero:
                  {{ riego.pagousuariomoduloriegos }}</v-list-item-subtitle
                >
                <v-list-item-subtitle class="texto2"
                  >Riego Numero: {{ riego.usuarionombre }}</v-list-item-subtitle
                >
              </v-list-item-content>

              <v-list-item-action>
                <v-row>
                  <v-btn icon>
                    <v-icon color="grey lighten-1" @click="ver(riego)"
                      >visibility</v-icon
                    >
                  </v-btn>

                  <v-btn icon>
                    <v-icon
                      color="grey lighten-1"
                      @click="actualizar(riego)"
                      v-if="riego.riegofecha == fecha() && rol == 2"
                      >engineering</v-icon
                    >
                    <v-icon
                      color="grey lighten-1"
                      @click="actualizar(riego)"
                      v-if="rol == 1"
                      >engineering</v-icon
                    >
                  </v-btn>

                  <v-btn icon>
                    <v-icon
                      color="grey lighten-1"
                      @click="eliminar(riego)"
                      v-if="riego.riegofecha == fecha() && rol == 2"
                      >delete</v-icon
                    >
                    <v-icon
                      color="grey lighten-1"
                      @click="eliminar(riego)"
                      v-if="rol == 1"
                      >delete</v-icon
                    >
                  </v-btn>
                </v-row>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-app>
    </div>

    <v-container v-if="vernuevo == 1">
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-alert dense type="info"> Datos de la Ficha de Riego </v-alert>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <v-text-field
            v-model="pagousuariomoduloriegos"
            label="Numero de Riegos Actuales"
            outlined
            type="number"
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="3" sm="3" md="3">
          <v-btn
            @click="pagousuariomodulobuscar()"
            fab
            dark
            color="primary"
            :disabled="vsver == 1"
          >
            <v-icon dark>search</v-icon>
          </v-btn>
        </v-col>

        <v-col cols="9" sm="9" md="9">
          <v-text-field
            v-model="pagousuariomoduloid"
            label="Numero de la Ficha Pagada"
            outlined
            type="number"
            @keyup.enter="pagousuariomodulobuscar()"
            @keydown.tab="pagousuariomodulobuscar()"
            v-on:blur="pagousuariomodulobuscar()"
            :readonly="vsver == 1"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <v-text-field
            v-model="telefono"
            label="Telefono del Usuario"
            outlined
            type="number"
            :readonly="vsactualizar == 1"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="12">
          <v-dialog
            ref="dialog1"
            v-model="modal1"
            :return-value.sync="riegofecha"
            persistent
            width="350px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="riegofecha"
                label="Fecha del Riego"
                prepend-icon="event"
                v-on="on"
                :readonly="vsactualizar == 1"
              ></v-text-field>
            </template>
            <v-date-picker v-model="riegofecha" scrollable locale="es-es">
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal1 = false">Cancel</v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.dialog1.save(riegofecha)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <v-text-field
            v-model="usuariomodulonombrecompleto"
            label="Nombre Completo "
            outlined
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="6" sm="6" md="6">
          <v-text-field
            v-model="cuenta"
            label="Cuenta "
            outlined
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="6" sm="6" md="6">
          <v-text-field
            v-model="subcuenta"
            label="Sub Cuenta"
            outlined
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <v-text-field
            v-model="ejidonombre"
            label="Ejido "
            outlined
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="6" sm="6" md="6">
          <v-text-field
            v-model="supfisica"
            label="Sup Fisica "
            outlined
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="6" sm="6" md="6">
          <v-text-field
            v-model="supriego"
            label="Sup Riego "
            outlined
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <v-text-field
            v-model="cultivonombre"
            label="Cultivo "
            outlined
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="6" sm="6" md="6">
          <v-text-field
            v-model="cultivonumeroderiegos"
            label="Cultivos Pagados "
            outlined
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="6" sm="6" md="6">
          <v-text-field
            v-model="pagousuariomodulosupriegopagada"
            label="Hectareas Pagadas "
            outlined
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <v-text-field
            v-model="pagousuariomodulohectareasregadas"
            label="Hectareas ya Regadas "
            outlined
            type="number"
            :readonly="vsactulaizayapago == 0"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <v-text-field
            v-model="hectareasaregar"
            label="Hectareas a Regar Actual "
            outlined
            type="number"
            :readonly="vsver == 1"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <v-select
            v-model="riegosubcultivo"
            :items="riegosubcultivoselect"
            outlined
            label="Sub Cultivo"
          ></v-select>
        </v-col>

        <v-col cols="12" md="4">
          <b-form-timepicker
            id="timepicker-buttons1"
            now-button
            reset-button
            :locale="locale"
            v-model="abierto"
            placeholder="Abre el Riego"
            size="lg"
            :readonly="vsactualizar == 1"
          ></b-form-timepicker>
        </v-col>

        <v-col cols="12" md="2">
          <v-select
            v-model="ampm1"
            :items="ampm1select"
            outlined
            label="A.M."
          ></v-select>
        </v-col>

        <v-col cols="12" md="4">
          <b-form-timepicker
            id="timepicker-buttons2"
            now-button
            reset-button
            :locale="locale"
            v-model="cerrado"
            placeholder="Cierra el Riego"
            :readonly="vsactualizar == 1"
            size="lg"
          ></b-form-timepicker>
        </v-col>

        <v-col cols="12" md="2">
          <v-select
            v-model="ampm2"
            :items="ampm2select"
            outlined
            label="A.M."
          ></v-select>
        </v-col>

        <v-col cols="12" md="12">
          <v-select
            v-model="canalid"
            :items="canalselect"
            label="Nombre del Canal"
            outlined
            :readonly="vsactualizar == 1"
          ></v-select>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <v-text-field
            v-model="horasregadas"
            label="Horas Regadas"
            outlined
            type="number"
            @keyup.enter="calculavolumen()"
            @keydown.tab="calculavolumen()"
            v-on:blur="calculavolumen()"
            :readonly="vsactualizar == 1"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <v-text-field
            v-model="qlps"
            label="Q.L.P.S"
            outlined
            type="number"
            @keyup.enter="calculavolumen()"
            @keydown.tab="calculavolumen()"
            v-on:blur="calculavolumen()"
            :readonly="vsactualizar == 1"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <v-text-field
            v-model="volumen"
            label="Volumen"
            outlined
            readonly
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="text-center">
        <v-btn class="mx-2" fab dark large @click="close">
          <v-icon dark> close </v-icon>
        </v-btn>
        <v-btn
          class="mx-2"
          fab
          dark
          large
          @click="guardar"
          v-if="botonver == 0"
        >
          <v-icon dark> save </v-icon>
        </v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import * as moment from "moment";
import "moment-duration-format";

export default {
  data() {
    return {
      // Variable
      fecha1: moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD"),
      fecha2: moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD"),
      modal: false,
      modal1: false,
      //
      valor: 0,
      vernuevo: 0,
      pagousuariomoduloid: "",
      cuenta: "",
      subcuenta: "",
      usuariomodulonombrecompleto: "",
      ejidonombre: "",
      supfisica: "",
      supriego: "",
      cultivonombre: "",
      pagousuariomoduloriegos: "",
      cultivonumeroderiegos: "",
      pagousuariomodulosupriegopagada: "",
      pagousuariomodulohectareasregadas: "",
      hectareasaregar: "",
      value: "",
      abierto: "",
      cerrado: "",
      locale: "es-Es",
      horasregadas: "",
      volumen: "",
      qlps: "",
      cultivoid: "",
      canalid: "",
      telefono: "",
      buscar: "",
      vsactualizar: 0,
      vsactulaizayapago: 0,
      ampm1: "A.M.",
      ampm2: "A.M.",
      //
      listaArray: [],
      canalselect: [],
      riegos: [],
      ampm1select: [
        { text: "A.M.", value: "A.M." },
        { text: "P.M.", value: "P.M." },
      ],
      ampm2select: [
        { text: "A.M.", value: "A.M." },
        { text: "P.M.", value: "P.M." },
      ],
      riegosubcultivoselect: [],
      //
      vsabierto: "",
      vscerrado: "",
      vsver: 0,
      riegofecha: moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD"),
      modal1: false,
      botonver: 0,
      botonactualiza: 0,
      riegoid: "",
      rol: this.$store.state.usuario.rolid,
      hectareasfisicas: 0,
      hectareasriego: 0,
      totalhasriego: 0,
      hecvolumen: 0,
    };
  },

  computed: {},

  created() {
    this.listar();
    this.selectcanal();
  },

  methods: {
    setNow() {
      const now = new Date();
      // Grab the HH:mm:ss part of the time string
      this.value = now.toTimeString().slice(0, 8);
    },
    fecha() {
      return moment(new Date(), "YYYY-MM-DD").format("YYYY-MM-DD");
    },
    clearTime() {
      this.value = "";
    },
    ver(riego) {
      this.botonactualiza = 0;
      this.botonver = 1;
      this.vsver = 1;
      this.vsactualizar = 1;
      this.vernuevo = 1;
      this.riegoid = riego.riegoid;
      this.pagousuariomoduloid = riego.pagousuariomoduloid;
      this.cuenta = riego.cuenta;
      this.subcuenta = riego.subcuenta;
      this.usuariomodulonombrecompleto = riego.usuariomodulonombrecompleto;
      this.ejidonombre = riego.ejidonombre;
      this.supfisica = riego.supfisica;
      this.supriego = riego.supriego;
      this.cultivonombre = riego.cultivonombre;
      this.pagousuariomoduloriegos = riego.pagousuariomoduloriegos;
      this.cultivonumeroderiegos = riego.cultivonumeroderiegos;
      this.pagousuariomodulosupriegopagada =
        riego.pagousuariomodulosupriegopagada;
      this.pagousuariomodulohectareasregadas =
        riego.pagousuariomodulohectareasregadas;
      this.hectareasaregar = 0;
      this.horasregadas = riego.horasregadas;
      this.canalid = riego.canalid;
      this.abierto = riego.riegoabre;
      this.cerrado = riego.riegocierra;
      this.qlps = riego.qlps;
      this.volumen = riego.volumen;
      this.riegofecha = riego.riegofecha;
      this.telefono = riego.telefono;
      this.riegosubcultivo = riego.riegosubcultivo;
    },
    actualizar(riego) {
      this.botonactualiza = 1;
      this.botonver = 0;
      this.vsver = 1;
      this.vsactualizar = 0;
      this.vsactulaizayapago = 1;
      this.vernuevo = 1;
      this.riegoid = riego.riegoid;
      this.pagousuariomoduloid = riego.pagousuariomoduloid;
      this.cuenta = riego.cuenta;
      this.subcuenta = riego.subcuenta;
      this.usuariomodulonombrecompleto = riego.usuariomodulonombrecompleto;
      this.ejidonombre = riego.ejidonombre;
      this.supfisica = riego.supfisica;
      this.supriego = riego.supriego;
      this.cultivonombre = riego.cultivonombre;
      this.pagousuariomoduloriegos = riego.pagousuariomoduloriegos;
      this.cultivonumeroderiegos = riego.cultivonumeroderiegos;
      this.pagousuariomodulosupriegopagada =
        riego.pagousuariomodulosupriegopagada;
      this.pagousuariomodulohectareasregadas =
        riego.pagousuariomodulohectareasregadas;
      this.hectareasaregar = 0;
      this.horasregadas = riego.horasregadas;
      this.canalid = riego.canalid;
      this.abierto = riego.riegoabre;
      this.cerrado = riego.riegocierra;
      this.qlps = riego.qlps;
      this.volumen = riego.volumen;
      this.riegofecha = riego.riegofecha;
      this.telefono = riego.telefono;
      this.riegosubcultivo = riego.riegosubcultivo;
    },
    nuevoriego() {
      this.limpiar();
      this.vernuevo = 1;
      this.vsver = 0;
      this.vsactualizar = 0;
      this.vsactulaizayapago = 0;
      this.botonver = 0;
    },
    close() {
      this.limpiar();
      this.vernuevo = 0;
      this.vsver = 0;
    },
    calculavolumen() {
      this.volumen = (3600 * this.horasregadas * this.qlps) / 1000;
    },
    limpiar() {
      this.vsver = 0;
      this.botonactualiza = 0;
      this.riegoid = "";
      this.pagousuariomoduloid = "";
      this.cuenta = "";
      this.subcuenta = "";
      this.usuariomodulonombrecompleto = "";
      this.ejidonombre = "";
      this.supfisica = "";
      this.supriego = "";
      this.cultivonombre = "";
      this.pagousuariomoduloriegos = "";
      this.cultivonumeroderiegos = "";
      this.pagousuariomodulosupriegopagada = "";
      this.pagousuariomodulohectareasregadas = "";
      this.hectareasaregar = "";
      this.horasregadas = "";
      this.cultivoid = "";
      this.abierto = "";
      this.cerrado = "";
      this.qlps = "";
      this.volumen = "";
      this.canalid = "";
      this.telefono = "";
      this.riegosubcultivo = "";
    },
    listar() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      let url = "";
      if (me.rol == 1) {
        url =
          "api/riegos/listar/" +
          me.$store.state.usuario.usuarioid +
          "/" +
          me.fecha1 +
          "/" +
          me.fecha2;
      }
      if (me.rol == 3) {
        url = "api/riegos/listartodos/" + me.fecha1 + "/" + me.fecha2;
      }

      if (me.rol == 2) {
        url =
          "api/riegos/listar/" +
          me.$store.state.usuario.usuarioid +
          "/" +
          me.fecha1 +
          "/" +
          me.fecha2;
      }

      me.hectareasfisicas = 0;
      me.hectareasriego = 0;
      me.totalhasriego = 0;
      me.hecvolumen = 0;
      axios
        .get(url, configuracion)
        .then(function(response) {
          me.riegos = response.data.riego;
          me.riegos.map(function(x) {
            if (x.usuarioid == me.$store.state.usuario.usuarioid) {
              if (x.pagousuariomoduloriegos == 1) {
                me.hectareasfisicas = (
                  parseFloat(me.hectareasfisicas) +
                  parseFloat(x.pagousuariomodulohectareasregadas)
                ).toFixed(2);
              }
              if (x.pagousuariomoduloriegos > 1) {
                me.hectareasriego = (
                  parseFloat(me.hectareasriego) +
                  parseFloat(x.pagousuariomodulohectareasregadas)
                ).toFixed(2);
              }

              me.totalhasriego = (
                parseFloat(me.totalhasriego) +
                parseFloat(x.pagousuariomodulohectareasregadas)
              ).toFixed(2);
              me.hecvolumen = (
                parseFloat(me.hecvolumen) + parseFloat(x.volumen)
              ).toFixed(2);
            }
          });
        })
        .catch(function(error) {
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },
    listarlike() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      let url = "";
      if (me.buscar == "" && me.rol == 2) {
        url = "api/riegos/listar/" + me.$store.state.usuario.usuarioid;
      }
      if (me.buscar == "" && me.rol == 1) {
        url = "api/riegos/listartodos";
      }
      if (!me.buscar == "") {
        url = "api/riegos/listarlike/" + me.buscar;
      }
      axios
        .get(url, configuracion)
        .then(function(response) {
          me.riegos = response.data.riego;
        })
        .catch(function(error) {
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },
    guardar() {
      if (this.pagousuariomoduloid == "") {
        this.$swal("No se a Capturado La Ficha de Riego");
        return;
      }

      if (this.telefono == "") {
        this.$swal("No se a Capturado el Telefono del Usuario");
        return;
      }

      if (this.riegofecha == "") {
        this.$swal("No se a Capturado La Fecha de Riego");
        return;
      }

      if (this.abierto == "") {
        this.$swal("No se a Capturado la Hora de Inicio");
        return;
      }

      if (this.cerrado == "") {
        this.$swal("No se a Capturado la Hora de Cierre");
        return;
      }

      if (this.canalid == "") {
        this.$swal("No se a Capturado el Canal");
        return;
      }

      if (this.horasregadas == "") {
        this.$swal("No se a Capturado las Horas Regadas");
        return;
      }

      if (this.qlps == "") {
        this.$swal("No se a Capturado Q.L.P.S");
        return;
      }

      if (this.volumen == "") {
        this.$swal("No se a capturado el Volumen");
        return;
      }

      if (this.cultivoid == 1) {
        if (this.riegosubcultivo == "") {
          this.$swal("No Se Ha Capturado El SubCultivo");
          return;
        }
      }

      if (this.cultivoid == 2) {
        if (this.riegosubcultivo == "") {
          this.$swal("No Se Ha Capturado El SubCultivo");
          return;
        }
      }

      if (this.botonactualiza == 0) {
        var qs = require("qs");
        var data = qs.stringify({
          json:
            '{"pagousuariomoduloid":"' +
            this.pagousuariomoduloid +
            '","cuenta":"' +
            this.cuenta +
            '","subcuenta":"' +
            this.subcuenta +
            '","usuariomodulonombrecompleto":"' +
            this.usuariomodulonombrecompleto +
            '","ejidonombre":"' +
            this.ejidonombre +
            '","supfisica":"' +
            this.supfisica +
            '","supriego":"' +
            this.supriego +
            '","cultivonombre":"' +
            this.cultivonombre +
            '","cultivonumeroderiegos":"' +
            this.cultivonumeroderiegos +
            '","pagousuariomoduloriegos":"' +
            this.pagousuariomoduloriegos +
            '","pagousuariomodulosupriegopagada":"' +
            this.pagousuariomodulosupriegopagada +
            '","pagousuariomodulohectareasregadas":"' +
            this.hectareasaregar +
            '","cultivoid":"' +
            this.cultivoid +
            '","riegoabre":"' +
            this.abierto +
            " " +
            this.ampm1 +
            '","riegocierra":"' +
            this.cerrado +
            " " +
            this.ampm2 +
            '","riegocanal":"' +
            this.canalid +
            '","horasregadas":"' +
            this.horasregadas +
            '","qlps":"' +
            this.qlps +
            '","volumen":"' +
            this.volumen +
            '","usuarioid":"' +
            this.$store.state.usuario.usuarioid +
            '","canalid":"' +
            this.canalid +
            '","riegofecha":"' +
            this.riegofecha +
            '","telefono":"' +
            this.telefono +
            '","riegosubcultivo":"' +
            this.riegosubcultivo +
            '"}',
        });
      }

      if (this.botonactualiza == 1) {
        var qs = require("qs");
        var data = qs.stringify({
          json:
            '{"pagousuariomoduloid":"' +
            this.pagousuariomoduloid +
            '","pagousuariomodulohectareasregadas":"' +
            this.pagousuariomodulohectareasregadas +
            '","riegoabre":"' +
            this.abierto +
            '","riegocierra":"' +
            this.cerrado +
            '","riegocanal":"' +
            this.canalid +
            '","horasregadas":"' +
            this.horasregadas +
            '","qlps":"' +
            this.qlps +
            '","volumen":"' +
            this.volumen +
            '","canalid":"' +
            this.canalid +
            '","riegofecha":"' +
            this.riegofecha +
            '","telefono":"' +
            this.telefono +
            '","riegosubcultivo":"' +
            this.riegosubcultivo +
            '"}',
        });
      }

      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      // Guarda
      if (me.botonactualiza == 0) {
        me.$swal({
          icon: "warning",
          title: "Estas Seguro de Guardar",
          text:
            "El Usuario: " +
            me.usuariomodulonombrecompleto +
            " Numero de Ficha: " +
            me.pagousuariomoduloid +
            "Fecha de Riego: " +
            me.riegofecha,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Guardar",
        }).then((result) => {
          if (result.value) {
            axios
              .post("api/riegos/crear", data, configuracion)
              .then(function(response) {
                me.botonver = 1;
                me.limpiar();
                me.listar();
                me.$swal("Guardado", "Se a Guardado con Exito", "success");
                me.close();
              })
              .catch(function(error) {
                console.log(error);
                if (error.status === 401) {
                  me.$swal("La Sesión a Expirado");
                  me.$store.dispatch("salir");
                }
              });
          }
        });
      }

      // Actualiza
      if (me.botonactualiza == 1) {
        me.$swal({
          icon: "warning",
          title: "Estas Seguro de Actualizar",
          text:
            "El Usuario: " +
            me.usuariomodulonombrecompleto +
            " Numero de Ficha: " +
            me.pagousuariomoduloid,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Guardar",
        }).then((result) => {
          if (result.value) {
            axios
              .put("api/riegos/actualizar/" + me.riegoid, data, configuracion)
              .then(function(response) {
                me.botonver = 1;
                me.limpiar();
                me.listar();
                me.$swal("Guardado", "Se a Guardado con Exito", "success");
                me.close();
              })
              .catch(function(error) {
                if (error.status === 401) {
                  me.$swal("La Sesión a Expirado");
                  me.$store.dispatch("salir");
                }
              });
          }
        });
      }
    },
    pagousuariomodulobuscar() {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/pagousuariomodulos/listarid/" + this.pagousuariomoduloid,
          configuracion
        )
        .then(function(response) {
          me.$swal(
            "La Fecha del riego es: " + me.riegofecha + " esta Segur@ ?"
          );
          if (
            response.data.pagousuariomodulo.pagousuariomoduloriegos >=
            response.data.pagousuariomodulo.cultivonumeroderiegos
          ) {
            me.$swal("Esta Ficha ya Realizo el Numero de Riegos que Pago");
            me.vernuevo = 0;
            me.limpiar();
            return;
          }

          if (
            parseFloat(
              response.data.pagousuariomodulo.pagousuariomoduloriegos
            ) == 0
          ) {
            me.pagousuariomoduloriegos = 1;
          } else {
            me.pagousuariomoduloriegos =
              parseFloat(
                response.data.pagousuariomodulo.pagousuariomoduloriegos
              ) + 1;
          }

          me.cuenta = response.data.pagousuariomodulo.cuenta;
          me.subcuenta = response.data.pagousuariomodulo.subcuenta;
          me.usuariomodulonombrecompleto =
            response.data.pagousuariomodulo.usuariomodulonombrecompleto;
          me.ejidonombre = response.data.pagousuariomodulo.ejidonombre;
          me.supfisica = response.data.pagousuariomodulo.supfisica;
          me.supriego = response.data.pagousuariomodulo.supriego;
          me.cultivonombre = response.data.pagousuariomodulo.cultivonombre;

          me.cultivonumeroderiegos =
            response.data.pagousuariomodulo.cultivonumeroderiegos;
          me.pagousuariomodulosupriegopagada =
            response.data.pagousuariomodulo.pagousuariomodulosupriegopagada;
          me.pagousuariomodulohectareasregadas =
            response.data.pagousuariomodulo.pagousuariomodulohectareasregadas;
          me.hectareasaregar = (
            parseFloat(me.pagousuariomodulosupriegopagada) -
            parseFloat(me.pagousuariomodulohectareasregadas)
          ).toFixed(2);
          me.cultivoid = response.data.pagousuariomodulo.cultivoid;
          me.telefono = response.data.pagousuariomodulo.telefono;

          if (me.cultivoid == 2) {
            me.riegosubcultivoselect = [
              { text: "REPOLLO", value: "REPOLLO" },
              { text: "LECHUGA", value: "LECHUGA" },
              { text: "TOMATE", value: "TOMATE" },
              { text: "CEBOLLA", value: "CEBOLLA" },
              { text: "CILANTRO", value: "CILANTRO" },
              { text: "CALABAZA", value: "CALABAZA" },
              { text: "PEREJIL", value: "PEREJIL" },
              { text: "PAPA", value: "PAPA" },
              { text: "CHILE", value: "CHILE" },
            ];
          }

          if (me.cultivoid == 1) {
            me.riegosubcultivoselect = [
              { text: "AVENA F.", value: "AVENA F." },
              { text: "AVENA G.", value: "AVENA G." },
            ];
          }

          if (me.cultivoid == 11) {
            me.riegosubcultivoselect = [
              { text: "SORGO F.", value: "SORGO F." },
              { text: "SORGO G.", value: "SORGO G." },
            ];
          }

          if (me.cultivoid != 1 && me.cultivoid != 2) {
            me.riegosubcultivoselect = [{ text: " ", value: " " }];
          }
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },
    selectcanal() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/canales/listar", configuracion)
        .then(function(response) {
          listaArray = response.data.canal;
          listaArray.map(function(x) {
            me.canalselect.push({
              text: x.canalnombre,
              value: x.canalid,
            });
          });
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },
    eliminar(riego) {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      // Actualiza

      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Actualizar",
        text:
          "El Usuario: " +
          riego.usuariomodulonombrecompleto +
          " Numero de Ficha: " +
          riego.pagousuariomoduloid,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
      }).then((result) => {
        if (result.value) {
          axios
            .put("api/riegos/eliminar/" + riego.riegoid, {}, configuracion)
            .then(function(response) {
              me.botonver = 1;
              me.limpiar();
              me.listar();
              me.$swal("Eliminado", "Se a Eliminado con Exito", "success");
              me.close();
            })
            .catch(function(error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {
                me.limpiar();
                me.listar();
                me.close();
                me.$swal("No se a Eliminado el Riego Checar");
              }
            });
        }
      });
    },
  },
};
</script>

<style>
.texto {
  font-size: 9px;
  font-weight: bold;
}

.texto2 {
  font-size: 8px;
  font-weight: bold;
}

.texto1 {
  background-color: #ffffff;
  font-size: 13px;
  font-weight: bold;
  height: 50px;
  background-color: transparent;
}
</style>
